//To get details about Warranty of a Product
export default class VerifyProduct {
    QrData = "";
    ProductId = 0;
}